import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <>
       {/*Begin footer wrapper*/}
       <div className="footer-wrapper type2">
      <footer className="foooter-container">
        <div className="container">
          <div className="footer-middle">
            <div className="row">
              <div className="col-md-4 col-sm-12 col-xs-12 animated footer-col">
                <div className="contact-footer">
                  <div className="logo-footer">
                    <Link to="/">
                      <img src="images/newlogo.png" alt="LITAANA" className="footer-logo-img" />
                    </Link>
                  </div>
                  <div className="contact-desc">
                    <p className="text-light footer-desc">
                      LIT Alumni Association North America — connecting alumni of Laxminarayan Institute of Technology across North America through events, scholarships, and community.
                    </p>
                  </div>
                  <div className="contact-phone-email">
                    {/* Old: +1 (999) 999-9999, info@litaana.com */}
                    {/* <span className="contact-email">
                      <a href="mailto:globallitalumni@gmail.com">globallitalumni@gmail.com</a>
                    </span> */}
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-sm-12  col-xs-12 animated footer-col">
                <div className="links-footer">
                  <div className="row">
                    <div className="col-sm-4 col-xs-12">
                      <h6 className="heading-bold">DASHBOARD</h6>
                      <ul className="list-unstyled no-margin">
                        <li>
                        <Link to="/">OVERVIEW</Link>
                        </li>
                        <li>
                        <Link to="/event">EVENTS</Link>
                        </li>
                        <li>
                          <Link to="/donation">DONATION</Link>
                        </li>
                        <li>
            
                         <Link to="/membership">MEMBERSHIP</Link>
                        </li>
                      </ul>
                    </div>
                    <div className="col-sm-4 col-xs-12"> 
                      <h6 className="heading-bold">ABOUT US</h6>
                      <ul className="list-unstyled no-margin">
                        <li>
                        <Link to="/about">ABOUT</Link>
                        </li>
                        <li>
                        <Link to="/project">VISION & MISSION</Link>
                        </li>
                        <li>
                          <Link to="/gallery">GALLERY</Link>
                        </li>
                        <li>
                        <Link to="/contactus">CONTACT US</Link>
                        </li>
                        <li>
                        <Link to="/privacy-policy">PRIVACY POLICY</Link>
                        </li>
                      </ul>
                    </div>
                    {/* <div className="col-sm-4 col-xs-12">
                      <h6 className="heading-bold">SUPPORT</h6>
                      <ul className="list-unstyled no-margin">
                        <li>
                          <a href="job-detail.html">FAQ</a>
                        </li>
                        <li>
                          <a href="about-us.html#contacts">CONTACT US</a>
                        </li>
                        <li>
                          <a href="blog.html">ORGANIZER</a>
                        </li>
                        <li>
                          <a href="blog-single-fullwith.html">SOCIAL</a>
                        </li>
                      </ul>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-12 col-xs-12 animated footer-col">
                <div className="links-social">
                  <div className="login-dashboard">
                    <Link
                     to="/contactus"
                      className="bg-color-theme text-center text-regular"
                    >
                      CONTACT US
                    </Link>
                  </div>
                  <ul className="list-inline text-center">
                    {/* WhatsApp link hidden until group invite URL is available
                    <li>
                      <a href="#">
                        <i className="fa fa-whatsapp" aria-hidden="true" /> Whatsapp
                      </a>
                    </li>
                    */}
                    {/* <li>
                      <a href="#">
                        <i className="fa fa-instagram" aria-hidden="true" />
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-facebook" aria-hidden="true" />
                      </a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom text-center">
            <p className="copyright text-light">
              ©2025 LIT Alumni Association North America Chapter
            </p>
            <p className="copyright text-light" style={{ fontSize: '0.85rem', marginTop: '8px' }}>
              A registered 501(c)(3) nonprofit organization | EIN: 39-2341136 | Incorporated in Texas, USA | May 2025
            </p>
            <p className="copyright text-light" style={{ fontSize: '0.85rem' }}>
              Donations are tax-deductible to the extent permitted by law.
            </p>
          </div>
        </div>
      </footer>
    </div>
    {/*End footer wrapper*/}
    </>
  )
}
